// extracted by mini-css-extract-plugin
export var button = "_c-0";
export var buttonContent = "_c-e";
export var buttonGroup = "_c-c";
export var dontRestrainIconWidth = "_c-a";
export var dropdownButton = "_c-b";
export var iconContainer = "_c-9";
export var lg = "_c-4";
export var md = "_c-3";
export var pending = "_c-f";
export var sm = "_c-2";
export var spinner = "_c-d";
export var squared = "_c-8";
export var wrapText = "_c-g";
export var xl = "_c-5";
export var xs = "_c-1";
export var xxl = "_c-6";
export var xxxl = "_c-7";